import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import TauriImage from "../TauriImage/TauriImage";
import './OpalAccordionCardV1.css';
import { Link } from "react-router-dom";
import { activityClassification } from "../../visualizations/visualizations";

const OpalAccordionCardV1 = ({
    item,
    selectedCard,
    setSelectedCard,
    search,
    onSelectItem
}) => {
    const statusIcon = {
        0: "/Images/material-symbols--pending-actions.svg",
        1: "/Images/material-symbols--check.svg",
        2: "/Images/akar-icons--person-cross.svg",
        3: "/Images/mdi--hourglass.svg",
        4: "/Images/mdi--check-decagram.svg",
        5: "/Images/material-symbols--check-advanced.svg",
        8: "/Images/mdi--account-check-outline.svg",
    };


    const highlightText = (text, query) => {
        if (!query) return text;
        const regex = new RegExp(`(${query})`, "gi");
        return text.split(regex).map((part, index) =>
            part.toLowerCase() === query.toLowerCase() ? (
                <span key={index} className="highlighted-text">{part}</span>
            ) : (
                part
            )
        );
    };

    function formatTime(timeString) {
        if (!timeString) return "";

        const [hours, minutes] = timeString.split(":").map(Number);
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        date.setSeconds(0);

        // Format: 1am, 2pm, etc.
        let formatted = date.toLocaleTimeString([], {
            hour: 'numeric',
            hour12: true,
        });

        return formatted.toLowerCase().replace(/\s/g, ''); // remove space before am/pm
    }

    const truncate = (text, max) => {
        if (!text) return "";
        return text.length > max ? text.substring(0, max) + "..." : text;
    };

    useEffect(() => {
        if (selectedCard === item.ID) {
            onSelectItem(item);
        }
    }, []);

    return (
        <Link
            to={`/coverage/${item.ID}`}
            className={`card-v1 mb-2`}
            onClick={() => {
                setSelectedCard(item.ID);
                onSelectItem(item);
            }}
        >
            <div className={`custom-card mb-2 card-body ${selectedCard === item.ID ? "active-card" : ""} p-3`}>
                {item?.Activity?.Classification === activityClassification.Event ?
                    <>
                        <Card.Title className="d-flex justify-content-between">
                            {highlightText(item.Activity?.Description?.toUpperCase(), search)}
                            <div className="d-flex ms-auto">
                                <TauriImage
                                    localImage={"/Images/mdi--calendar-star.svg"}
                                    alt={"event"}
                                    className="sidebar-icon"
                                    color={"#7264CB"}
                                />
                            </div>
                        </Card.Title>
                        <Card.Subtitle className="remarks-ellipsis">
                            {truncate(item.Remarks, 70)}
                        </Card.Subtitle>
                        <div className="d-flex justify-content-between">
                            <div className="d-flex ms-auto">
                                {item?.Joint &&
                                    <TauriImage
                                        localImage="/Images/mdi--handshake-outline.svg"
                                        alt={`status-${item.Status}`}
                                        className="sidebar-icon"
                                    />
                                }
                                <TauriImage
                                    localImage={statusIcon[item.Status]}
                                    alt={`status-${item.Status}`}
                                    className="sidebar-icon"
                                />
                            </div>
                        </div>
                    </> :
                    <>
                        <Card.Title>
                            {highlightText(item.Customer.Name?.toUpperCase(), search)}
                        </Card.Title>
                        <Card.Subtitle>
                            {highlightText(item.Customer.AddressDetail, search)}
                        </Card.Subtitle>
                        <div className="d-flex justify-content-between">
                            <Card.Text>
                                {formatTime(item.Customer?.Time_Start)}
                                {item.Customer?.Time_Start && <span className="mx-1">-</span>}
                                {formatTime(item.Customer?.Time_End)}
                            </Card.Text>
                            <div className="d-flex">
                                {item?.Joint &&
                                    <TauriImage
                                        localImage="/Images/mdi--handshake-outline.svg"
                                        alt={`status-${item.Status}`}
                                        className="sidebar-icon ms-1"
                                    />
                                }
                                <TauriImage
                                    localImage={statusIcon[item.Status]}
                                    alt={`status-${item.Status}`}
                                    className="sidebar-icon ms-1"
                                />
                            </div>
                        </div>
                    </>
                }
            </div>
        </Link>

    );
};

export default OpalAccordionCardV1;
